const TENANCY = '/vuokrani';
const PAYMENT_INFO = '/maksutiedot';
const ADMIN = '/hallinta';
const LIVING = '/asuminen';
const RESIDENT_COMMITTEE = '/asukastoimikunta';

const YSAATIO_ROOT = '/irtisano';

export const Routes = {
  HOME: '/',
  SIGN_IN: '/kirjaudu',
  RESET_PASSWORD: '/unohtunut-salasana',
  SIGN_UP: '/rekisteroidy',
  FEEDBACK: '/palaute',
  APARTMENT_CHANGE_APPROVAL: '/vaihtoilmoitukset/:id/:secret',
  APARTMENT_SWAP: '/asuminen/asunnonvaihto/vaihto',
  PROFILE: '/omat-tiedot',
  OwnForms: {
    ALL_FORMS: '/omat-lomakkeet',
    FORM: '/omat-lomakkeet/:id',
    UPDATE_FORM: '/omat-lomakkeet/muokkaa/:id',
  },
  SEARCH: '/haku/:query',
  CONTACT_REQUEST_SUCCESS: '/onnistui',
  TERMINATE_LEASE: '/sopimuksen-irtisanominen',
  Tenancy: {
    PAYMENT_SUCCESS: `${TENANCY}${PAYMENT_INFO}/onnistui`,
    PAYMENT_ERROR: `${TENANCY}${PAYMENT_INFO}/virhe`,
  },
  Administrative: {
    HOME: ADMIN,
    // Note: If any changes are made to the FORM_REVIEW URL, ensure corresponding changes
    // are reflected in the backend email sending functionality
    FORM_REVIEW: `${ADMIN}/lomakkeet/:token`,
    IMPERSONATE: `${ADMIN}/kirjaudu`,
  },

  ResidentCommittee: {
    MEETING_MINUTES: `${LIVING}${RESIDENT_COMMITTEE}/kokouspoytakirja`,
    ACTION_PLAN: `${LIVING}${RESIDENT_COMMITTEE}/toimintasuunnitelma`,
    ACTION_REPORT: `${LIVING}${RESIDENT_COMMITTEE}/toimintakertomus`,
    GENERAL_EXPENSE_REPORT: `${LIVING}${RESIDENT_COMMITTEE}/kuluselvitys`,
    TRAVEL_EXPENSE_REPORT: `${LIVING}${RESIDENT_COMMITTEE}/matkalasku`,
    EVENT_INVITE: `${LIVING}${RESIDENT_COMMITTEE}/tapahtumakutsu`,
  },
};

export const YSaatioRoutes = {
  HOME: YSAATIO_ROOT,
  FORM: `${YSAATIO_ROOT}/lomake`,
  SIGN_IN: `${YSAATIO_ROOT}/kirjaudu`,
  RESET_PASSWORD: `${YSAATIO_ROOT}/unohtunut-salasana`,
  SIGN_UP: `${YSAATIO_ROOT}/rekisteroidy`,
};
